'use client';

import { useGSAP } from '@gsap/react';
import clsx from "clsx";
import gsap from 'gsap';
import { useRef } from 'react';
import Cta from '@/components/cta/cta';
import Plus from '@/components/icon/plus';
import Section from "@/components/section";
import { STORIES_BASE_PATH } from '@/constants/routes';
import StoriesGallery from './stories-gallery';
import StoriesHeading from './stories-heading';


export default function StoriesPage({ ugcStories, isDummy = false }) {
  const ctaRef = useRef(null);

  useGSAP(() => {
    const mm = gsap.matchMedia();

    mm.add('(prefers-reduced-motion: reduce)', () => {
      gsap.set(ctaRef.current, { opacity: 1 });
    });

    mm.add('(prefers-reduced-motion: no-preference)', () => {
      gsap.fromTo(ctaRef.current, {
        opacity: 0,
        y: 60,
      }, {
        opacity: 1,
        y: 0,
        duration: 0.8,
        delay: 0.9,
        ease: 'power3.out',
      });
    });
  }, []);

  const content = (
    <>
      <StoriesHeading
        text="Meet people and families who shaped American history in their own way. Then add your story."
        title="250 Stories"
      />
      <StoriesGallery items={ugcStories} />

      <div className="sticky bottom-(--space-7) flex justify-center z-20 pointer-events-none">
        <Cta
          ref={ctaRef}
          className="cta-icon cta-icon-stroke-theme opacity-0 pointer-events-auto"
          href={`${STORIES_BASE_PATH}/250-stories/upload`}
          transitionName="overlay-in"
        >
          <Plus className="!w-4" />
          <span className="whitespace-nowrap">Submit your story</span>
        </Cta>
      </div>
    </>
  );


  return (
    <div className={clsx("w-full font-sans page", isDummy && 'pointer-events-none')}>
      <Section theme="main-dark" className={clsx("pt-header", !isDummy && 'pb-31.75 lg:pb-19')} isTopSection={true}>
        {isDummy ? (
          <div className="max-height-dummy-section">
            {content}
          </div>
        ) : (
          content
        )}
      </Section>
    </div>
  )
}
